import { useEffect } from 'react'
import { Popup as ConsolePopup } from '@integration-app/console/components/Popup'
import useParentWindow from '@integration-app/ui/hooks/useParentWindow'

import { EmbedIsolateLayout } from './EmbedIsolateLayout'
import OpenInNewTabButton from '../EmbedPopup/elements/OpenInNewTabButton'

export function EmbedIsolateWindow({ children }: { children: React.ReactNode }) {
  const { handshake } = useParentWindow()

  useEffect(() => {
    // Send handshake to the parent window so that it knows we are alive.
    void handshake()
  }, [])

  return (
    <ConsolePopup.Root>
      <EmbedIsolateLayout.Window>
        <OpenInNewTabButton />
        {children}
      </EmbedIsolateLayout.Window>
    </ConsolePopup.Root>
  )
}
